import React, { useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/material';
import ButtonComponent from '../../../components/form/ButtonComponent';

interface ShiftSaveButtonsProps {
  handleSave: (type: any) => void;
  processing: boolean;
  publishing: boolean;
  shiftStatus: number;
}
const ShiftSaveButtons: React.FC<ShiftSaveButtonsProps> = ({
  handleSave,
  processing,
  publishing,
  shiftStatus,
}) => {
  return shiftStatus === 0 || shiftStatus === 2 || shiftStatus === 3 ? (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'end',
        gap: 2,
        alignItems: 'center',
        mt: 1,
      }}
    >
      <ButtonComponent
        errors={''}
        color="secondary"
        keyName="savedraftbutton"
        disabled={processing || publishing}
        label={
          processing
            ? 'Saving...'
            : shiftStatus === 2 || shiftStatus === 3
              ? 'Save'
              : 'Save Draft'
        }
        onClick={() => {
          if (shiftStatus === 2 || shiftStatus === 3) handleSave(3);
          else handleSave(0);
        }}
        currentRecord={null}
      />

      <ButtonComponent
        errors={''}
        keyName="publishbutton"
        label={
          publishing
            ? 'Saving...'
            : shiftStatus === 2 || shiftStatus === 3
              ? 'Complete Shift'
              : 'Publish'
        }
        disabled={processing || publishing}
        onClick={() => {
          if (shiftStatus === 2 || shiftStatus === 3) handleSave(4);
          else handleSave(1);
        }}
        currentRecord={null}
      />
    </Box>
  ) : (
    <Box></Box>
  );
};

export default ShiftSaveButtons;
